module.exports = __webpack_public_path__ + "img/circle-check-solid.0ddd09a3.svg";